import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE,
});

api.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const refreshToken = localStorage.getItem('refresh_token');
      if (refreshToken) {
        try {
          const response = await axios.post(`${process.env.REACT_APP_API_BASE}/api/v1/users/refresh/`, {
            refresh: refreshToken
          });

          const { access, refresh } = response.data;

          localStorage.setItem('access_token', access);
          localStorage.setItem('refresh_token', refresh);

          originalRequest.headers['Authorization'] = `Bearer ${access}`;
          return api(originalRequest);
        } catch (refreshErr) {
          console.error('Refresh token expired or invalid:', refreshErr);
          localStorage.clear();
          window.dispatchEvent(new Event('session_expired'));
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
